/**
 * Type of non-alcoholic drinks.
 */
export type NonAlcoholicDrinkType =
  | 'COFFEE'
  | 'TEA_OR_MEDICINAL_TEA'
  | 'MINERAL_WATER'
  | 'SODA_POP'
  | 'ICE_TEA'
  | 'ENERGY_DRINK'
  | 'COCKTAIL_SYRUP'
  | 'SYRUP'
  | 'FRUIT_OR_VEGETABLE_JUICE';

export const NonAlcoholicDrinkType = {
  Coffee: 'COFFEE' as NonAlcoholicDrinkType,
  TeaOrMedicinalTea: 'TEA_OR_MEDICINAL_TEA' as NonAlcoholicDrinkType,
  MineralWater: 'MINERAL_WATER' as NonAlcoholicDrinkType,
  SodaPop: 'SODA_POP' as NonAlcoholicDrinkType,
  IceTea: 'ICE_TEA' as NonAlcoholicDrinkType,
  EnergyDrink: 'ENERGY_DRINK' as NonAlcoholicDrinkType,
  CocktailSyrup: 'COCKTAIL_SYRUP' as NonAlcoholicDrinkType,
  Syrup: 'SYRUP' as NonAlcoholicDrinkType,
  FruitOrVegetableJuice: 'FRUIT_OR_VEGETABLE_JUICE' as NonAlcoholicDrinkType,
};
